<div class="client-page-content">
  <div class="content-header">
    <h2>{{ 'CLIENT.clientDay.title' | translate }}</h2>
  </div>
  <ul class="options" *ngIf="!loading">
    <li *ngFor="let day of days" (click)="selectDay(day)">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <a class="option">{{day?.day | dateFix | date:'EEEE'}}</a>
        </div>
        <div class="d-flex align-items-center">
          <span class="d-flex align-items-center">
            {{day?.day | dateFix | date:dateFormat(day?.day)}}
            <i class="material-icons icon pl-1">keyboard_arrow_right</i>
          </span>
        </div>
      </div>
    </li>
    <li >
      <!-- <a class="option viewmore" (click)="loadMoreDays(lastLoadedDate)">Depois de {{lastLoadedDate.format('DD/MM')}}...</a> -->
      <a *ngIf="!stopLoadingDays" class="option viewmore" (click)="loadMoreDays(lastLoadedDate)">{{ 'CLIENT.clientDay.seeMoreDates' | translate }}</a>
      <p *ngIf="stopLoadingDays" class="mt-3 text-secondary text-center">{{ 'CLIENT.clientDay.noMoreAvailableDates' | translate }}</p>
    </li>
  </ul>
  <app-loader-list-placeholder *ngIf="loading"></app-loader-list-placeholder>
</div>
